import { useTranslation } from "react-i18next";
import PageHeader from "../../components/common/pageheader/PageHeader";

const MyLessonsPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("pages.myLessons.title")} />
      <p>{t("pages.myLessons.description")}</p>
    </div>
  );
};

export default MyLessonsPage;
